import groq from 'groq'

export const getNewsItemsListQuery = groq`
  *[_type == "newsItem" && language == $language] | order(publishedAt desc) {
    _createdAt,
    _id,
    _updatedAt,
    href,
    translatedHref,
    image,
    imageBgColor,
    language,
    publishedAt,
    title,
    type,
  }
`

export const getPressReleasesListQuery = groq`
  *[_type == "pressRelease" && language == $language] {
    _createdAt,
    _id,
    _updatedAt,
    content,
    ingress,
    landscapeImage,
    quadraticImage,
    slug,
    title,
  }
`

export const getPressReleaseDetailQuery = groq`
  *[_type == "pressRelease" && language == $language && slug.current == $slug][0] {
    _createdAt,
    _id,
    _updatedAt,
    content,
    landscapeImage,
    metaDescription,
    title,
  }
`

export const getMediabankAssetsListQuery = groq`
  *[_type == "mediabankAsset" && language == $language] {
    _createdAt,
    _id,
    _updatedAt,
    bgStyle,
    credit,
    image,
    license,
    slug,
    title,
    type,
  }
`

export const getMediabankAssetDetailQuery = groq`
  *[_type == "mediabankAsset" && language == $language && slug.current == $slug][0] {
    _createdAt,
    _id,
    _updatedAt,
    bgStyle,
    credit,
    image,
    license,
    slug,
    title,
    type,
  }
`
